import React from 'react'
import ExhibitorPortal from '../src/pages/ExhibitorPortal/ExhibitorPortal';

const exhibitorportal = () => {
  return (
    <div>
      <ExhibitorPortal />
    </div>
  )
}

export default exhibitorportal;